import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Form,
  ListGroup,
  ListGroupItem,
  Modal,
  Row,
} from "react-bootstrap";
import { Progress } from 'shards-react'
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import AddSubscription from './AddSubscription';
import {
  userActions,
  subscriptionActions,
} from '../../actions';
import { useFormik } from 'formik';
import moment from 'moment-jalaali'
import AuthImage from "../common/AuthImage";

const UserDetails = ({ user }) => {
  const dispatch = useDispatch();
  const subscription = useSelector(state => state.subscription.currentSubscription);
  const remainSub = useSelector(state => state.subscription.subRemainedDays);
  const [show, setShow] = useState(false);
  const [sub, setSub] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [pendingUpdate, setPendingUpdate] = useState(null);

  useEffect(() => {
    if (!user || !user._id) return;
    dispatch(subscriptionActions.resetState());
    dispatch(subscriptionActions.getUserSubscription(user._id));
  }, [user, dispatch]);

  useEffect(() => {
    const periodStart = _.get(subscription, 'currentPeriodStart');
    const periodEnd = _.get(subscription, 'currentPeriodEnd');
    if (!periodStart || !periodEnd) {
      setSub(null);
      return;
    }

    const periodDays = moment(periodEnd).diff(moment(periodStart), 'days', true);
    const remainingDays = Number(remainSub);
    if (!Number.isFinite(periodDays) || periodDays <= 0 || !Number.isFinite(remainingDays)) {
      setSub(null);
      return;
    }

    const percent = Math.max(
      0,
      Math.min(100, Math.round((remainingDays * 100) / periodDays)),
    );
    setSub({ days: periodDays, percent });
  }, [subscription, remainSub]);

  const handleShow = () => {
    setShow(true);
  }
  const handleClose = () => {
    setShow(false);
    setShowPassword(false);
    setPendingUpdate(null);
  }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      userId: _.get(user, '_id', ''),
      status: _.get(user, 'status', ''),
      verified: _.get(user, 'verified', ''),
      password: '',
      loginFailed: _.get(user, 'loginFailed', ''),
      role: _.get(user, 'role', ''),
      group: _.get(user, 'group', ''),
    },
    validate: values => {
      const errors = {};
      if (values.password && values.password.length < 6) {
        errors.password = 'Password must contain at least 6 characters.';
      }
      return errors;
    },
    onSubmit: values => {
      const payload = { ...values };
      if (!payload.password) delete payload.password;
      if (!payload.group) delete payload.group;
      if (payload.status === 'active' && _.get(user, 'status') !== 'active') {
        payload.verified = true;
        payload.loginFailed = 0;
      }
      const changes = [];
      if (payload.role !== _.get(user, 'role')) {
        changes.push(`Role: ${_.get(user, 'role')} → ${payload.role}`);
      }
      if (payload.status !== _.get(user, 'status')) {
        changes.push(`Status: ${_.get(user, 'status')} → ${payload.status}`);
      }
      if (payload.group !== _.get(user, 'group')) {
        changes.push(`Group: ${_.get(user, 'group', 'none')} → ${payload.group || 'none'}`);
      }
      if (payload.password) changes.push('Password will be replaced');

      setPendingUpdate({ payload, changes });
    },

  });

  const confirmUpdate = () => {
    if (!pendingUpdate) return;
    dispatch(userActions.update(pendingUpdate.payload));
    handleClose();
  };
  const accountProps = (user) => {
    let status;
    let role = <Badge variant="primary">{_.startCase(_.get(user, 'role'))}</Badge>;
    let group = <Badge variant="primary">{_.startCase(_.get(user, 'group'))}</Badge>;
    let verified = _.get(user, 'verified') ? <Badge variant="success">Verified</Badge> : <Badge variant="warning">Not Verified</Badge>;
    switch (_.get(user, 'status')) {
      case 'active':
        status = <Badge variant="success">Active</Badge>
        break;
      case 'waiting':
        status = <Badge variant="warning">Waiting</Badge>
        break;
      case 'block':
        status = <Badge variant="danger">{`Block (${_.get(user, 'loginFailed')} Login Failed)`}</Badge>
        break;
      default:
        break;
    }
    return (
      <div className="badgeBox">
        {verified}{status}{role}{group}
      </div>
    )
  }

  return (
    <>
      <Card className="mb-4 pt-3">
        <Card.Header className="border-bottom text-center">
          <Row>
            <Col>
              <h5 className="mb-0">{`${_.get(user, 'username', '')}`.trim()} </h5>
              {accountProps(user)}
              <AuthImage
                className="rounded-circle"
                src={`${process.env.REACT_APP_FILE_SERVER}/users/${_.get(user, '_id', _.get(user, 'userId'))}/avatar.png`}
                alt={`${_.get(user, 'details.firstname', '')} ${_.get(
                  user,
                  'details.lastname',
                  '',
                )}`.trim()}
                width="100"
                style={{ margin: '10px auto' }}
                fallbackSrc={require("./../../images/avatars/0.jpg")}
              />
              <br />
              <Button
                size="sm"
                variant="outline-primary"
                className="mb-2 rounded-pill"
                onClick={handleShow}
              >
                <i className="material-icons mr-1">edit</i> Edit Account
            </Button>
            </Col>
            {/* <Col>
              <Row>
                <span className="text-muted d-block mb-2">Role:</span>
                <span className="text-muted d-block mb-2">{_.get(user, 'role', '')}</span>
              </Row>
              <Row>
                <span className="text-muted d-block mb-2">Verified:</span>
                <span className="text-muted d-block mb-2">{_.get(user, 'verified', '')}</span>
              </Row>
              <Row>
                <span className="text-muted d-block mb-2">Status: </span>{userStatus(_.get(user, 'status'))}
              </Row>
              <Row>
                <span className="text-muted d-block mb-2">Login Failed:</span>
                <span className="text-muted d-block mb-2">{_.get(user, 'loginFailed', '')}</span>
              </Row>
              <Row>
                <span className="text-muted d-block mb-2">Passwoed:</span>
                <span className="text-muted d-block mb-2">********</span>
              </Row>

            </Col> */}
          </Row>
          <Row>


          </Row>
          {/* <div className="mb-3 mx-auto">
        </div> */}
        </Card.Header>
        <ListGroup variant="flush">
          <ListGroupItem className="px-4">
            <div className="progress-wrapper">
              <strong className="text-muted d-block mb-2">
                {_.get(sub, 'days') ? `${remainSub}/${Math.round(sub.days)}` : 'No active plan'}
              </strong>
              <Progress
                className="progress-sm"
                value={_.get(sub, 'percent', 0)}
              >
                <span className="progress-value">
                  {_.get(sub, 'percent', 0)}%
            </span>
              </Progress>
            </div>
          </ListGroupItem>
          <ListGroupItem>
            <AddSubscription userId={_.get(user, '_id')} />
          </ListGroupItem>
          {/* <ListGroupItem className="p-4">
            <strong className="text-muted d-block mb-2">
              {_.get(user, 'metaTitle', 'Account')}
            </strong>
            <span>{_.get(user, 'metaValue', '50')}</span>
          </ListGroupItem> */}
        </ListGroup>
      </Card>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Account</Modal.Title>
        </Modal.Header>
        <form id="edit-user-account-form" onSubmit={formik.handleSubmit}>
          <Modal.Body>
            {pendingUpdate ? (
              <>
                <Alert variant="warning">
                  This is a sensitive account operation. Confirm the changes before continuing.
                </Alert>
                {pendingUpdate.changes.length ? (
                  <ul className="mb-0">
                    {pendingUpdate.changes.map(change => <li key={change}>{change}</li>)}
                  </ul>
                ) : (
                  <p className="mb-0">No sensitive account fields were changed.</p>
                )}
              </>
            ) : (
              <>
                <Row>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label htmlFor="role">Role</Form.Label>
                      <Form.Control
                        as="select"
                        id="role"
                        name="role"
                        value={formik.values.role}
                        onChange={formik.handleChange}
                      >
                        <option value="client">Client</option>
                        <option value="operator">Operator</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label htmlFor="status">Account status</Form.Label>
                      <Form.Control
                        as="select"
                        id="status"
                        name="status"
                        value={formik.values.status}
                        onChange={formik.handleChange}
                      >
                        <option value="active">Active</option>
                        <option disabled hidden value="waiting">Waiting</option>
                        <option value="block">Blocked</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                {formik.values.role === 'operator' && (
                  <Form.Group>
                    <Form.Label htmlFor="group">Operator group</Form.Label>
                    <Form.Control
                      as="select"
                      id="group"
                      name="group"
                      value={formik.values.group}
                      onChange={formik.handleChange}
                    >
                      <option value="">No group</option>
                      <option value="vibino">Vibino</option>
                      <option value="bdok">Bdok</option>
                    </Form.Control>
                  </Form.Group>
                )}
                <Form.Group>
                  <Form.Label htmlFor="password">New password</Form.Label>
                  <div className="user-password-field">
                    <Form.Control
                      id="password"
                      name="password"
                      type={showPassword ? 'text' : 'password'}
                      autoComplete="new-password"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      isInvalid={Boolean(formik.errors.password)}
                      placeholder="Leave blank to keep the current password"
                    />
                    <Button
                      type="button"
                      variant="link"
                      onClick={() => setShowPassword(current => !current)}
                      aria-label={showPassword ? 'Hide password' : 'Show password'}
                    >
                      <i className="material-icons">
                        {showPassword ? 'visibility_off' : 'visibility'}
                      </i>
                    </Button>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.password}
                    </Form.Control.Feedback>
                  </div>
                  <Form.Text className="text-muted">
                    Passwords are never displayed or included in confirmation details.
                  </Form.Text>
                </Form.Group>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            {pendingUpdate ? (
              <>
                <Button type="button" variant="outline-secondary" onClick={() => setPendingUpdate(null)}>
                  Back
                </Button>
                <Button type="button" variant="danger" onClick={confirmUpdate}>
                  Confirm account update
                </Button>
              </>
            ) : (
              <>
                <Button type="button" variant="outline-secondary" onClick={handleClose}>Cancel</Button>
                <Button type="submit" variant="primary" disabled={!formik.isValid}>Review changes</Button>
              </>
            )}
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}

UserDetails.propTypes = {
  user: PropTypes.object,
};

UserDetails.defaultProps = {
  user: {},
};

export default UserDetails;
